import React from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function Sidebar() {
    return (
        <div>
            <Card className='animated-card mt-5' border="primary" style={{ border: '3px solid #0d6efd' }}>
                <Card.Body>
                    <Card.Title>CATUS LMS</Card.Title>
                    <hr />
                    <ul className="list-unstyled">
                        <li>
                            <Link to="/AirExportLogisticsSoftware" style={{ textDecoration: 'none', color: 'inherit' }}>
                                Air Export Logistics Software
                            </Link>
                        </li>
                        <li>
                            <Link to="/SeaExportLogisticsSoftware" style={{ textDecoration: 'none', color: 'inherit' }}>
                                Sea Export Logistics Software
                            </Link>
                        </li>
                        <li>
                            <Link to="/AirImportLogisticsSoftware" style={{ textDecoration: 'none', color: 'inherit' }}>
                                Air Import Logistics Software
                            </Link>
                        </li>
                        <li>
                            <Link to="/SeaImportLogisticsSoftware" style={{ textDecoration: 'none', color: 'inherit' }}>
                                Sea Import Logistics Software
                            </Link>
                        </li>
                        <li>
                            <Link to="/FinancialAccountingSoftware" style={{ textDecoration: 'none', color: 'inherit' }}>
                                Financial Accounting
                            </Link>
                        </li>
                        <li>
                            <Link to="/CustomisedBusinessEmailServices" style={{ textDecoration: 'none', color: 'inherit' }}>
                                Customised Business Email Services
                            </Link>
                        </li>
                        <li>
                            <Link to="/WebsiteDevelopment" style={{ textDecoration: 'none', color: 'inherit' }}>
                                Website Development
                            </Link>
                        </li>
                    </ul>

                </Card.Body>
            </Card>

            <Card className='my-4 animated-card' border="primary" style={{border: '3px solid #0d6efd' }}>
                <Card.Body>
                    <Card.Title>INDUSTRIES</Card.Title>
                    <hr />
                    <ul className="list-unstyled">
                        <li>
                            <Link to="/CatusLMS" style={{ textDecoration: 'none', color: 'inherit' }}>
                                Logistics
                            </Link>
                        </li>
                        <li>
                            <Link to="/LogisticsOperations" style={{ textDecoration: 'none', color: 'inherit' }}>
                                Freight Forwarders
                            </Link>
                        </li>
                        <li>
                            <Link to="/AirExportLogisticsSoftware" style={{ textDecoration: 'none', color: 'inherit' }}>
                                Air Freight Forwarders
                            </Link>
                        </li>
                        <li>
                            <Link to="/SeaExportLogisticsSoftware" style={{ textDecoration: 'none', color: 'inherit' }}>
                                Sea Freight Forwarders
                            </Link>
                        </li>
                        <li>
                            <Link to="/AirImportLogisticsSoftware" style={{ textDecoration: 'none', color: 'inherit' }}>
                                Air Import Freight Forwarders
                            </Link>
                        </li>
                        <li>
                            <Link to="/SeaImportLogisticsSoftware" style={{ textDecoration: 'none', color: 'inherit' }}>
                                Sea Import Freight Forwarders
                            </Link>
                        </li>
                        
                        <li>
                            <Link to="/LogisticsOperations" style={{ textDecoration: 'none', color: 'inherit' }}>
                                Custom House Agents
                            </Link>
                        </li>
                    </ul>

                </Card.Body>
            </Card>
        </div>
    )
}

export default Sidebar